import styled from "styled-components";

export const TabContainer = styled.div`
  width: 100%;
  align-self: flex-start;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  color: #101e8e;
`;

export const OutputContainer = styled.div`
  color: #101e8e;
  display: flex;
  flex-direction: column;
  width: 60%;
  gap: 2rem;
`;

export const PropertyDetail = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.3rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  width: 40%;
  align-items: center;
  justify-content: space-between;
`;

export const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: right;
  gap: 1rem;
  label {
    width: 100%;
    input {
      background: #fff;
      padding-left: 10px;
    }
    select {
      background: #e5eff2;
      width: 100%;
      padding-left: 10px;
      &:focus{
        outline: none;
      }
    }
  }
`;
